import {TStore} from 'models';

export const selectCompany = (state: TStore) => state?.company?.data;
